import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
`
